import { FaAngleRight as AngleRightIcon } from 'react-icons/fa';

export default AngleRightIcon;
